import styled from "styled-components";

export const Container = styled.div`
	background: ${({ theme }) => theme.white};
	padding: 0.4rem 0;
`;

export const AreaButton = styled.div`
	display: flex;
	justify-content: flex-end;
	padding: 0.4rem;
	gap: 1rem;
`;

interface IContainerRowProps {
	$notClickable?: boolean;
}

export const ContainerRow = styled.div<IContainerRowProps>`
	display: grid;
	grid-template-columns: 60px repeat(5, 1fr);
	grid-gap: 1rem;
	align-items: center;
	border: 1px solid ${({ theme }) => theme.grayDarker};
	border-radius: 4px;
	cursor: ${({ $notClickable }) => ($notClickable ? "default" : "pointer")};
	padding: 1.4rem 0.4rem 1rem;

	transition: background 0.2s ease-out;

	&:hover {
		background: ${({ theme }) => theme.grayLight};
	}

	.MuiInputBase-root {
		border: 1px solid ${({ theme }) => theme.grayDarker};
	}
`;

interface IContainerLabelProps {
	$labelContent: string;
}

export const ContainerLabel = styled.div<IContainerLabelProps>`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	height: 40px;
	width: inherit;

	&::before {
		content: "${({ $labelContent }) => $labelContent}";
		position: absolute;
		top: -20px;
		left: 0;
		padding: 0;
		font-size: 0.8rem;
		font-weight: bold;
		overflow: hidden;
		white-space: pre;
		text-overflow: ellipsis;
	}
`;

export const ValueOption = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	border: 1px solid ${({ theme }) => theme.grayDarker};
	border-radius: 8px;
	height: 100%;
	width: 100%;
	padding: 0 0.4rem;
	overflow: hidden;
`;

export const ValueOptionText = styled.span`
	display: -webkit-box;
	overflow: hidden;
	line-height: 1.2em;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
`;
